import { render, staticRenderFns } from "./ProductionInsuranceReport.vue?vue&type=template&id=56577e7c"
import script from "./ProductionInsuranceReport.vue?vue&type=script&lang=js"
export * from "./ProductionInsuranceReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports